/* src/app/components/app/app.component.scss */
.no-padding {
  padding-left: 0px;
  padding-right: 0px;
}
.e-dialog .e-dlg-content {
  padding: 0;
}
/*# sourceMappingURL=app.component.css.map */
